import React from 'react';
import Input from '../../base/Input/Input';
import PropTypes from 'prop-types';
import './Tooltip.scss';
import questionmark from '../../../content/images/questionmark.png';

const SerialNumberWithTooltip = ({ disabled, id, label, maxLength, name, onChange, onClick, placeholder, value }) => {
    
    return(
        <div>
            <div className="form-group col-xs-12">
                <label
                    className="control-label col-xs-12"
                    htmlFor={id}>
                    {label}
                </label>
                <div className="col-xs-12 col-sm-6">
                    <Input
                        className="form-control"
                        disabled={disabled}
                        id={id}
                        name={name}
                        maxLength={maxLength}
                        onChange={onChange}
                        onClick={onClick}
                        placeholder={placeholder}
                        type="text"
                        value={value} />
                </div>
            </div>
            <div className="imageTooltip col-xs-2">
                <img src={questionmark} />
            </div>
        </div>
    );
};

SerialNumberWithTooltip.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    inputDivClassName: PropTypes.string,
    label: PropTypes.string,
    labelClassName: PropTypes.string,
    maxLength: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
    ])
};

export default SerialNumberWithTooltip;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionComponents/ArticleSerialNumber/SerialNumberWithTooltip.js